/**********************************************************************************************************************/
/* FILE: hafas_webapp_subscription_sq.js                                                                              */
/**********************************************************************************************************************/
/* Subscriptions SQ */
HafasWebapp.prototype.subscriptions.sq = function (_me) {
  // SQ-Events -------------------------------------------------------------------------------------------------------
  // Stationssuche Formular abschicken
  Hafas.ps.sub('/sq/postForm', Hafas.bind(_me.Controller.SQ.postForm, _me));

  // Stationssuche Suggest auswahl
  Hafas.ps.sub("/suggest/selectitem/Station", Hafas.bind(function (loc) {
    _me.Controller.SQ.instance.setLocation(loc);
    if (Hafas.Config.Switches.useFavorites && Hafas.Config.Favorites.addLocationOnSuggest) {
      var depLocProducts = Hafas.Modules.Suggest.getSuggestInstanceById('Station').productRef;
      var depLocHistory  = {
        name: loc.name,
        lid : loc.lid,
        prod: depLocProducts
      };
      _me.Controller.Favorites.instance.addLocation(depLocHistory, 'History');
    }
    Hafas.Modules.Validation.resetErrorField('Station');
  }, _me));
  Hafas.ps.sub('/sq/setLocation/webapp', Hafas.bind(_me.Controller.SQ.setLocation, _me));
  Hafas.ps.sub('/sq/selectStopFromNearList', Hafas.bind(_me.Controller.SQ.selectStopFromNearList,_me));
  Hafas.ps.sub('/sq/setProductFormFilter', Hafas.bind(_me.Controller.SQ.setProductFormFilter,_me));
  if(Hafas.Config.SQ.useSmartDeparture === true) {
    Hafas.ps.sub('/favorites/update', Hafas.bind(_me.Controller.SQ.rerenderLinesNearby, _me));
  }
  if(Hafas.Config.SQ.useProductResultFilter === true) {
    Hafas.ps.sub('/sq/setProductResultFilter', Hafas.bind(_me.Controller.SQ.updateResultProductFilter, _me));
  }

  Hafas.ps.sub('/SQ/options/init', Hafas.bind(_me.Controller.SQ.initDirection,_me));

  // Stationssuche Produktauswahl
  Hafas.ps.sub("/sq/selectProduct", Hafas.bind(function (pCls, boolval) {
    _me.Controller.SQ.instance.setProductClass(parseInt(pCls), boolval);
    _me.Controller.SQ.options.setProduct(pCls, boolval);
    Hafas.ps.pub('/app/events/resize');
  }, _me));

  // Auswahl alle Produkt f�r Fahrplanauskunft
  Hafas.ps.sub("/sq/setAllProducts", function (onOrOff, parameter) {
    _me.Controller.SQ.setAllProducts(onOrOff);
  });

  // Stationssuche Time Mode
  Hafas.ps.sub("/sq/toggleTimeMode", Hafas.bind(_me.Controller.SQ.toggleTimeMode, _me));
  // Stationssuche Sort Mode
  Hafas.ps.sub("/sq/toggleSortMode", Hafas.bind(_me.Controller.SQ.toggleSortType, _me));

  // Geolocation Aktivierung (z.B. bei Alltype)
  Hafas.ps.sub('/common/currentPositionActivated/Station', Hafas.bind(function (data) {
    this.Controller.SQ.instance.setLocation(data);
  }, _me));

  /* Datumsauswahl Stationboard*/
  Hafas.ps.sub('/sq/setDate', Hafas.bind(_me.Controller.SQ.setDate,_me));
  Hafas.ps.sub('/sq/setTime', Hafas.bind(_me.Controller.SQ.setTime,_me));

  /* sollte nicht mehr notwendig sein, da im options-Modul gekapselt /mroe */
  /* Auswahl Anzahl Fahrten */
  /**Hafas.ps.sub('/sq/setSelectOption',
     Hafas.bind(_me.Controller.SQ.setOption,_me));  **/

  // Funktionalit�t f�r Favoriten-Stern in der Stations�bersicht
  Hafas.ps.sub('/sq/toggleLocationFavorite', Hafas.bind(_me.Controller.SQ.toggleLocationFavorite, _me));
  Hafas.ps.sub('/sq/checkLocationFavorite', Hafas.bind(_me.Controller.SQ.checkLocationFavorite, _me));
  Hafas.ps.sub('/sq/addStopToFav', Hafas.bind(_me.Controller.SQ.addStopToFav,_me));
  Hafas.ps.sub('/sq/removeStopFromFav', Hafas.bind(_me.Controller.SQ.removeStopFromFav,_me));


  // Allgemeines Rendern der Tabs. Achtung: "webapp" ist die ID der allg. stboard.id
  Hafas.ps.sub('/sq/dataChanged/webapp', Hafas.bind(_me.Controller.SQ.renderStationboardTabs, _me));


  Hafas.ps.sub('/sq/toggleDepArr', Hafas.bind(function (type) {
    if (type == "departure") {
      _me.Controller.SQ.instance.setBoardType("dep");
    }
    else if (type == "arrival") {
      _me.Controller.SQ.instance.setBoardType("arr");
    }
  }, _me));

  Hafas.ps.sub('/sq/setBoardType', Hafas.bind(function (type) {

    // ggf. blaetter-zaehler resetten
    if ((typeof _me.Controller.GUI.sq != 'undefined') && (typeof _me.Controller.GUI.sq.scroll != 'undefined')) {
      delete _me.Controller.GUI.sq.scroll;
    }
    _me.Controller.SQ.instance.setBoardType(type);

  }));

  Hafas.ps.sub('/sq/showResults', Hafas.bind(function (type) {

    // ggf. blaetter-zaehler resetten
    if ((typeof _me.Controller.GUI.sq != 'undefined') && (typeof _me.Controller.GUI.sq.scroll != 'undefined')) {
      delete _me.Controller.GUI.sq.scroll;
    }
    if (type == 'DEP' || type == 'ARR') {
      if (type == 'DEP') {
        var hciBoardType = 'dep';
      }
      else if (type == 'ARR') {
        var hciBoardType = 'arr';
      }
      _me.Controller.SQ.instance.setBoardType(hciBoardType);
    }

    if (_me.Controller.SQ.instance.getCurrentRequest() != null) {
      var request = _me.Controller.SQ.instance.getCurrentRequest();
      request.current.svcReqL[0].req.type = type;

      if (type == "departure") {
        request.current.svcReqL[0].req.type = "DEP";
      }
      else if (type == "arrival") {
        request.current.svcReqL[0].req.type = "ARR";
      }
    }
    _me.Controller.SQ.instance.search(function () {
    }, request);
  }, _me));


  /* Autorefresh vom Stationboard abschalten */
  Hafas.ps.sub('/app/switchContext', Hafas.bind(_me.Controller.SQ.stopAutorefresh, _me.Controller.SQ));
  Hafas.ps.sub('/app/events/closeResults', Hafas.bind(function (data) {
    if (data.appcontext == 'SQ') {
      this.stopAutorefresh();
    }
  }, _me.Controller.SQ));


  // SQ select from DateTimePicker
  Hafas.ps.sub('/dateTimePicker/selectDateTime/SQ_DTP', Hafas.bind(_me.Controller.SQ.selectDateTimeFromPicker, _me));

  // Stops near
  Hafas.ps.sub('/sq/getStopsNearby', Hafas.bind(_me.Controller.SQ.getLocationsNear, _me));

  // Switch to SQ Module from Map Toolbox
  Hafas.ps.sub('/sq/fromMapPos', function () {
    // Tracking
    Hafas.ps.pub('/tracking/event/mapflyout-stationboard-pressed', [ { typ: 'event', key: 'mapflyout-stationboard-pressed' } ]);
    Hafas.bind(_me.Controller.GUI.map.hide, _me)();
    _me.Controller.SQ.searchFromOtherContext.apply(_me, arguments);
  });

  Hafas.ps.sub('/sq/searchFromOtherContext', Hafas.bind(_me.Controller.SQ.searchFromOtherContext, _me));

  Hafas.ps.sub('/GUI/leaveContext/SQ', Hafas.bind(_me.Controller.SQ.cleanup, _me));
  Hafas.ps.sub('/GUI/closeView/SQ', Hafas.bind(_me.Controller.SQ.closeView, _me));
  Hafas.ps.sub('/GUI/restoreView/SQ', Hafas.bind(_me.Controller.SQ.restoreView, _me));

  // show further results (blaettern)
  Hafas.ps.sub('/sq/getFurtherResults', Hafas.bind(_me.Controller.SQ.getFurtherJourneys, _me));

  // Aktualisierung der GUI beim Entfernen der Richtungs-Option
  Hafas.ps.sub('/sq/clearDirection/webapp', Hafas.bind(function () {
    Hafas('#HFS_SQDirection').value = '';
    _me.Controller.SQ.options.setRandomParameter("HFS_SQDirection", "value", "");
    Hafas.ps.pub('/options/gui/toggle/delete', [{id: "HFS_SQDirection", visibility: false}]);
  }, _me));

  // Stboard Anzeige in der Toolbox
  Hafas.ps.sub('/GUI/sq/toggleMiniStboard', Hafas.bind(_me.Controller.SQ.toggleMiniStboard, _me));

  Hafas.ps.sub('/sq/details/expand', Hafas.bind(_me.Controller.SQ.toggleInfoDetails, _me));

  Hafas.ps.sub('/sq/printSearchLink', Hafas.bind(_me.Controller.SQ.printSearchLink, _me));

};
